import React, { useState } from 'react'

interface Tab {
  id: string
  label: string
  content: React.ReactNode
}

interface CustomTabsProps {
  tabs: Tab[]
  defaultTab?: string
}

export default function CustomTabs({ tabs, defaultTab }: CustomTabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].id)

  return (
    <div className="w-full">
      <div className="flex">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`px-4 py-2 text-sm font-medium transition-colors duration-200 mx-1 rounded-lg ${
              activeTab === tab.id
                ? 'text-primary-600 bg-primary-50'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label === 'Resume' ? 'Documents' : tab.label}
          </button>
        ))}
      </div>
      <div className="bg-background text-foreground pt-6">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  )
}

// Note: The actual addition of the "Interviews" tab should be done where the tabs are defined,
// typically in the parent component that uses CustomTabs.
// This component merely renders the tabs it receives.